import {
  FETCH_GRIEVANCES_REQUEST,
  FETCH_GRIEVANCES_SUCCESS,
  FETCH_GRIEVANCES_FAILURE,
  FETCH_GRIEVANCE_DETAILS_REQUEST,
  FETCH_GRIEVANCE_DETAILS_SUCCESS,
  FETCH_GRIEVANCE_DETAILS_FAILURE,
  FETCH_STATUS_MASTER_REQUEST,
  FETCH_STATUS_MASTER_SUCCESS,
  FETCH_STATUS_MASTER_FAILURE,
  FETCH_APPLICANT_DETAILS,
  FETCH_GRIEVANCE_ESCALATION_MATRIX_REQUEST,
  FETCH_GRIEVANCE_ESCALATION_MATRIX_SUCCESS,
  FETCH_GRIEVANCE_ESCALATION_MATRIX_FAILURE,
  FETCH_GRIEVANCE_SECTIONS_SUCCESS,
  FETCH_GRIEVANCE_SECTIONS_FAILURE,
  FETCH_GRIEVANCES_BY_SECTION_SUCCESS,
  FETCH_GRIEVANCE_SECTIONS_REQUEST,
  LOGOUT,
  LOGIN_SUCCESS,
  FETCH_USERS_SUCCESS,
  FETCH_CENTERS_SUCCESS,
  FETCH_GRANTS_SUCCESS,
  FETCH_GRANT_DETAILS_SUCCESS,
  FETCH_GRANT_HISTORY_SUCCESS,
  FETCH_GRANT_STATUS_OPTIONS_SUCCESS,
  FETCH_ESCALATION_MATRIX_SUCCESS,
  FETCH_EVENTS_SUCCESS,
  FETCH_POLICIES_REQUEST,
  FETCH_POLICIES_SUCCESS,
  FETCH_POLICIES_FAILURE,
  ADD_POLICY_REQUEST,
  ADD_POLICY_SUCCESS,
  ADD_POLICY_FAILURE,
  UPDATE_POLICY_REQUEST,
  UPDATE_POLICY_SUCCESS,
  UPDATE_POLICY_FAILURE,
  DELETE_POLICY_REQUEST,
  DELETE_POLICY_SUCCESS,
  DELETE_POLICY_FAILURE,
} from "../types";

const initialState = {
  grievances: [],
  user: localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null,
  token: localStorage.getItem("token") || null,
  loading: false,
  error: null,
  token: "",
  grievanceEscalationMatrix: [],
  grievanceSections: [],
  currentGrievance: null,
  loading: false,
  error: null,
  statusMasterList: [],
  loadingStatusMaster: false,
  statusMasterError: null,
  sectionsLoading: false,
  idCard: [],
  cardDetails: [],
  cardHistory: [],
  grievancecategoryMaster: [],
  users: [],
  centers: [],
  grants: [],
  sectionGrants: [],
  selectedGrant: [],
  grantHistory: [],
  Grant_Application_Details: "",
  statusOptions: [],
  escalationMatrix: [],
  events: [],
  policies: [],
  userDashborad: [],
  idcardDashborad: [],
  grantDashborad: [],
  grievanceDashborad: [],
  idcardDashborad: [],
  grantDashborad: [],
  grievanceDashborad: [],
  grantsescalaratedDashboard: [],
  grievancesescalaratedDashboard: [],
  eventsDashboard: [],
  locationMaster:[],
  getAllUser:[],
  userRoleMaster:[],
  getAllCenter:[],
  getAllRankList:[]
};

export default function grievanceReducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload.user,
        token: action.payload.token,
        error: null,
      };

    case LOGOUT:
      return {
        ...state,
        user: null,
        token: null,
      };

    case FETCH_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload || [],
        loading: false,
        error: null,
      };
    case FETCH_CENTERS_SUCCESS:
      return {
        ...state,
        centers: action.payload,
        loading: false,
      };
    case FETCH_GRANTS_SUCCESS:
      return {
        ...state,
        grants: action.payload,
        loading: false,
        error: null,
      };

    case "FETCH_GRANTS_BY_SECTION_SUCCESS":
      return {
        ...state,
        grants: action.payload, // Still update main grants array
        sectionGrants: action.payload, // Also store separately if needed
        loading: false,
        error: null,
      };
    case FETCH_GRANT_DETAILS_SUCCESS:
      return {
        ...state,
        selectedGrant: action.payload,
        loading: false,
        error: null,
      };

    case FETCH_GRANT_HISTORY_SUCCESS:
      return {
        ...state,
        grantHistory: action.payload,
        loading: false,
        error: null,
      };
    case "Grant_Application_Details":
      return {
        ...state,
        grantAppliactionDetails: action.payload,
      };
      case "Get_All_User_List":
        return {
          ...state,
          getAllUser: action.payload,
        }; case "Location_Master":
        return {
          ...state,
          locationMaster: action.payload,
        };
        case "UserRole_Master":
        return {
          ...state,
          userRoleMaster: action.payload,
        };
        case "Get_All_Center_List":
          return {
            ...state,
            getAllCenter: action.payload,
          };
          case "Get_All_Rank_List":
            return {
              ...state,
              getAllRankList: action.payload,
            };
        
    case FETCH_GRANT_STATUS_OPTIONS_SUCCESS:
      return {
        ...state,
        statusOptions: action.payload,
        loading: false,
        error: null,
      };
    case FETCH_ESCALATION_MATRIX_SUCCESS:
      return {
        ...state,
        escalationMatrix: action.payload,
        loading: false,
        error: null,
      };

    case FETCH_EVENTS_SUCCESS:
      return {
        ...state,
        events: action.payload,
        loading: false,
        error: null,
      };

    case FETCH_POLICIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_POLICIES_SUCCESS:
      return {
        ...state,
        policies: action.payload,
        loading: false,
        error: null,
      };

    case FETCH_POLICIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ADD_POLICY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ADD_POLICY_SUCCESS:
      return {
        ...state,
        policies: [...state.policies, action.payload],
        loading: false,
        error: null,
      };
    case ADD_POLICY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_POLICY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPDATE_POLICY_SUCCESS:
      return {
        ...state,
        policies: state.policies.map(policy =>
          policy.id === action.payload.id ? action.payload : policy
        ),
        loading: false,
        error: null,
      };
    case UPDATE_POLICY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case FETCH_GRIEVANCES_REQUEST:
    case FETCH_GRIEVANCE_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    // Delete policy
    case DELETE_POLICY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_POLICY_SUCCESS:
      return {
        ...state,
        loading: false,
        policies: state.policies.filter(p => String(p.POLICY_ID ?? p.id) !== String(action.payload)),
      };
    case DELETE_POLICY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "FETCH_ID_LIST":
      return {
        ...state,
        idCard: action.payload,
        loading: false,
        error: null,
      };
    case "Fetch_Card_Details":
      return {
        ...state,
        cardDetails: action.payload,
        loading: false,
        error: null,
      };
    case "Fetch_Card_History":
      return {
        ...state,
        cardHistory: action.payload,
        loading: false,
        error: null,
      };
    case "FETCH_GRIEVANCES_CATEGORY_MASTER":
      return {
        ...state,
        grievancecategoryMaster: action.payload,
        loading: false,
        error: null,
      };

    case FETCH_GRIEVANCES_SUCCESS:
      return {
        ...state,
        grievances: action.payload,
        loading: false,
        error: null,
      };

    case FETCH_GRIEVANCE_DETAILS_SUCCESS:
      return {
        ...state,
        currentGrievance: action.payload,
        loading: false,
        error: null,
      };
    case FETCH_APPLICANT_DETAILS:
      return {
        ...state,
        applicantDetails: action.payload,
      };
    case FETCH_GRIEVANCES_FAILURE:
    case FETCH_GRIEVANCE_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case FETCH_STATUS_MASTER_REQUEST:
      return {
        ...state,
        loadingStatusMaster: true,
        statusMasterError: null,
      };
    case FETCH_STATUS_MASTER_SUCCESS:
      return {
        ...state,
        statusMasterList: action.payload,
        loadingStatusMaster: false,
      };
    case FETCH_STATUS_MASTER_FAILURE:
      return {
        ...state,
        loadingStatusMaster: false,
        statusMasterError: action.payload,
      };
    case FETCH_GRIEVANCE_ESCALATION_MATRIX_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_GRIEVANCE_ESCALATION_MATRIX_SUCCESS:
      return {
        ...state,
        grievanceEscalationMatrix: action.payload,
        loading: false,
      };

    case FETCH_GRIEVANCE_ESCALATION_MATRIX_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case FETCH_GRIEVANCE_SECTIONS_REQUEST:
      return {
        ...state,
        sectionsLoading: true,
      };
    case FETCH_GRIEVANCE_SECTIONS_SUCCESS:
      return {
        ...state,
        grievanceSections: action.payload,
        sectionsLoading: false,
      };
    case FETCH_GRIEVANCE_SECTIONS_FAILURE:
      return {
        ...state,
        sectionsLoading: false,
      };
    case FETCH_GRIEVANCES_BY_SECTION_SUCCESS:
      return {
        ...state,
        grievances: action.payload,
        loading: false,
      };
    case "User_Dashboard_Data":
      return {
        ...state,
        userDashborad: action.payload || [],
      };
    case "IdCard_Dashboard_Data":
      return {
        ...state,
        idcardDashborad: action.payload || [],
      };
    case "Grants_Dashboard_Data":
      return {
        ...state,
        grantDashborad: action.payload || [],
      };
    case "Grievance_Dashboard_Data":
      return {
        ...state,
        grievanceDashborad: action.payload || [],
      };

    case "Grantsescalarated_Dashboard_Data":
      return {
        ...state,
        grantsescalaratedDashboard: action.payload || [],
      };
    case "Grievancesescalarated_Dashboard_Data":
      return {
        ...state,
        grievancesescalaratedDashboard: action.payload || [],
      };
    case "Events_Dashboard_Data":
      return {
        ...state,
        eventsDashboard: action.payload || [],
      };

    default:
      return state;
  }
}
